module.exports = __webpack_public_path__ + "img/title_bgrg.145336e5.png";